module.exports = __webpack_public_path__ + "img/Vkontakte.ebef605e.svg";